<template>
  <div class="sy-nav">
    <van-nav-bar class="title" :title="$route.meta.title" fixed />
    <div class="content">
      <div class="logo" align="center">
        <img :src="requestData.headUrl">
      </div>
      <div class="big-text" align="center">
        <span>{{ requestData.name }}想要添加您为好友</span>
      </div>
      <div v-if="requestData.state === 'REQUEST'">
        <div class="bind-btn" @click="goPage()">
          <img src="../../assets/images/family/apply_btn.png">
        </div>
        <div class="register-btn" @click="goRefuse()">
          <img src="../../assets/images/family/refuse_btn.png">
        </div>
      </div>
      <div v-else class="resut-ok">
        <div v-if="requestData.state === 'AGREE'">已同意</div>
        <div v-if="requestData.state === 'REFUSE'">{{ $t('viewBase.a41') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { userGroupRequestAgree, userGroupRequestRefuse, getUserGroupRequestUser } from '@/api/family'
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      requestData: {},
      requestId: ''
    }
  },
  created() {
    this.requestId = this.$route.query.requestId
    this.getUserGroupRequestUser()
  },
  methods: {

    getUserGroupRequestUser: function() {
      var this_ = this
      getUserGroupRequestUser({ requestId: this_.requestId }).then(res => {
        if (res.data.code === 0) {
          this_.requestData = res.data.data
        } else {
          Toast(res.data.msg)
        }
      })
    },
    goPage: function() {
      // 同意操作
      var this_ = this
      Dialog.confirm({
        message: this.$t('viewBase.a45')
      }).then(() => {
        Toast.loading({
          message: this.$t('viewBase.a43'),
          forbidClick: 0
        })
        userGroupRequestAgree({ requestId: this_.requestId }).then(res => {
          Toast.clear()
          if (res.data.code === 0 && res.data.data) {
            this_.requestData.state = 'AGREE'
          }
        })
      })
    },
    goRefuse: function() {
      // 拒绝操作
      var this_ = this
      Dialog.confirm({
        message: this.$t('viewBase.a44')
      }).then(() => {
        Toast.loading({
          message: this.$t('viewBase.a43'),
          forbidClick: 0
        })
        userGroupRequestRefuse({ requestId: this_.requestId }).then(res => {
          Toast.clear()
          if (res.data.code === 0 && res.data.data) {
            this_.requestData.state = 'REFUSE'
          }
        })
      })
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
        //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .resut-ok{
    margin-top: 60px;
    padding: 0px 16px;
    div{
      background-color: #C2C2C2;
      color: #fff;
      padding: 8px;
      border-radius: 3px;
      font-size: 17px;
      text-align: center;
    }
  }
  .sy-nav {
    height: 100vh;
    background: white;
  }
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .content {
    background-color: white;
    .logo{
      padding-top: 2.04rem;
      img{
        border-radius: 50%;
        width: 91px;
        height: 91px;
      }
    }
    .big-text{
      padding-top: 35px;
      font-size:19px;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
      color:rgba(0,0,0,1);
    }
    .small-text{
      margin-top: 16px;
      padding: 0px 12px;
      font-size:13px;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
      color:rgba(125,125,125,1);
      line-height:19px;
    }
    .bind-btn{
      padding-top: 60px;
      img{
        padding: 0px 16px;
        width: 100%;
        height: 42px;
      }
    }
    .register-btn{
      padding-top: 20px;
      img{
        padding: 0px 16px;
        width: 100%;
        height: 42px;
      }
    }
  }
</style>

